import { render, staticRenderFns } from "./ClienteLoginView.vue?vue&type=template&id=c6cadd74&scoped=true"
import script from "./ClienteLoginView.vue?vue&type=script&lang=js"
export * from "./ClienteLoginView.vue?vue&type=script&lang=js"
import style0 from "./ClienteLoginView.vue?vue&type=style&index=0&id=c6cadd74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cadd74",
  null
  
)

export default component.exports